export const ACTIVITY_OLD_LOGS = 'ACTIVITY_OLD_LOGS'
export const ACTIVITY_NEW_LOGS = 'ACTIVITY_NEW_LOGS'
export const ACTIVITY_CACHE_TIME = 'ACTIVITY_CACHE_TIME'

export default {
    ACTIVITY_NEW_LOGS,
    ACTIVITY_OLD_LOGS,
    ACTIVITY_CACHE_TIME
}
